<template>
    <div class="doc-toolbar">
        <b-button-group size="sm" class="mr-1">
            <b-button variant="outline-secondary" title="굵게" @mousedown.prevent @click="cmd('bold')">
                <b>B</b>
            </b-button>
            <b-button variant="outline-secondary" title="기울임" @mousedown.prevent @click="cmd('italic')">
                <i>I</i>
            </b-button>
            <b-button variant="outline-secondary" title="밑줄" @mousedown.prevent @click="cmd('underline')">
                <u>U</u>
            </b-button>
        </b-button-group>

        <b-button-group size="sm" class="mr-1">
            <label class="doc-toolbar__color mb-0" title="글자 색" @mousedown.prevent>
                <span class="doc-toolbar__color-swatch">A</span>
                <input type="color" class="doc-toolbar__color-input" aria-label="글자 색" @input="cmd('foreColor', $event.target.value)">
            </label>
        </b-button-group>

        <b-button-group size="sm" class="mr-1">
            <b-button variant="outline-secondary" title="링크" @mousedown.prevent @click="$emit('url-request', 'link')">
                링크
            </b-button>
            <b-button variant="outline-secondary" title="이미지" @mousedown.prevent @click="$emit('url-request', 'image')">
                이미지
            </b-button>
        </b-button-group>

        <b-button-group size="sm">
            <b-button variant="outline-secondary" title="서식 지우기" @mousedown.prevent @click="cmd('removeFormat')">
                서식 지우기
            </b-button>
        </b-button-group>

        <!-- 링크·이미지 주소 입력(부모가 선택 범위를 저장한 뒤 openUrl 로 연다) -->
        <b-modal
            v-model="urlModal.show"
            :title="urlModal.kind === 'link' ? '링크 넣기' : '이미지 넣기'"
            size="sm"
            centered
            ok-title="넣기"
            cancel-title="취소"
            :ok-disabled="!urlValid"
            @shown="$refs.urlInput.focus()"
            @ok="submitUrl"
        >
            <b-form-group
                :label="urlModal.kind === 'link' ? '링크 주소' : '이미지 주소'"
                label-size="sm"
                :description="urlModal.kind === 'link'
                    ? 'http://, https://, mailto: 로 시작하는 주소나 {{ }} 변수를 넣으세요.'
                    : 'http:// 또는 https:// 로 시작하는 이미지 주소를 넣으세요.'"
                class="mb-0"
            >
                <b-form-input
                    ref="urlInput"
                    v-model="urlModal.value"
                    type="url"
                    size="sm"
                    placeholder="https://example.com"
                    :state="urlModal.value && !urlValid ? false : null"
                    @keydown.enter.prevent="submitUrl"
                />
            </b-form-group>
        </b-modal>
    </div>
</template>

<script>
// 본문 서식 툴바. 버튼 mousedown 에서 preventDefault 해 iframe 편집 selection 을 잃지
// 않고, click 시 부모(MailDocCanvas)로 command 를 올린다. 실제 execCommand 는 부모가
// iframe 문서에 실행한다.

// 'https://' 만 있거나 javascript: 같은 주소는 넣지 않는다. 링크는 mailto: 와 기존 템플릿처럼 {{ origin }} 같은 변수도 허용.
function isHttpUrl(value) {
    if (/\s/.test(value)) return false
    try {
        const u = new URL(value)
        return (u.protocol === 'http:' || u.protocol === 'https:') && !!u.hostname
    } catch (e) {
        return false
    }
}
const URL_CHECKS = {
    link: v => isHttpUrl(v) || /^mailto:[^\s@]+@\S+$/i.test(v) || /^\{\{[^}]+\}\}\S*$/.test(v),
    image: isHttpUrl,
}

export default {
    name: 'DocToolbar',
    data() {
        return {
            urlModal: { show: false, kind: 'link', value: '' },
        }
    },
    computed: {
        urlValid() {
            return URL_CHECKS[this.urlModal.kind](this.urlModal.value.trim())
        },
    },
    methods: {
        cmd(command, value) {
            this.$emit('command', { command, value: value == null ? null : value })
        },
        openUrl(kind) {
            this.urlModal = { show: true, kind, value: '' }
        },
        submitUrl(bvEvent) {
            if (!this.urlValid) {
                if (bvEvent && bvEvent.preventDefault) bvEvent.preventDefault()
                return
            }
            this.cmd(this.urlModal.kind === 'link' ? 'createLink' : 'insertImage', this.urlModal.value.trim())
            this.urlModal.show = false
        },
    },
}
</script>

<style scoped>
/* 긴 본문 아래쪽을 편집할 때도 보이게 스크롤 영역 위에 붙인다 */
.doc-toolbar {
    position: sticky;
    top: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    padding: 6px 8px;
    border: 1px solid #dee2e6;
    border-bottom: 0;
    border-radius: 4px 4px 0 0;
    background: #f8f9fa;
}
.doc-toolbar__color {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 31px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
}
.doc-toolbar__color-swatch {
    font-weight: bold;
    border-bottom: 3px solid #3d5afe;
    line-height: 1;
}
.doc-toolbar__color-input {
    position: absolute;
    inset: 0;
    opacity: 0;
    cursor: pointer;
}
</style>
